import React from 'react';

type DialogFooterProps = {
  children?: React.ReactNode;
  withTopDivider?: boolean;
  dividerStyle?: React.CSSProperties;
};

export default function DialogFooter({ children, withTopDivider = false, dividerStyle }: DialogFooterProps) {
  return (
    <>
      {withTopDivider && <div className="divider" style={dividerStyle} />}
      <div className="footer-buttons">{children}</div>
    </>
  );
}
